












































































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import dayjs from 'dayjs';

import {ConnectionServiceProxy,CloseNodeDto} from "@/service-proxies/app-v2/iot-extranetv2-serve.service-proxies";

@Component({
  components: {

  },
})
export default class PcList extends Vue {
  conServProxy = new ConnectionServiceProxy();
  columns = [
    {
      title: '操作',
      key: 'action',
      scopedSlots: {
        customRender: 'action'
      },
    },
    {
      title: '节点ID',
      dataIndex: 'nodeId',
      key: 'nodeId',
      scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
      },
      onFilter: (value, record) =>
          record.nodeId
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
    },
    {
      title: '状态',
      dataIndex: 'state',
      key: 'state',
    },
    {
      title: '流量',
      dataIndex: 'displayTraffic',
      key: 'displayTraffic',
    },
    {
      title: '登录时间',
      dataIndex: 'loginTime',
      key: 'loginTime',
      scopedSlots: {
        customRender: 'loginTime'
      },
    }
  ];

  data = [];
  nodeIdSelect = ''

  searchInput=null;
  searchText='';
  searchedColumn=null;

  handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    this.searchText = selectedKeys[0];
    this.searchedColumn = '';
  }

  handleReset(clearFilters) {
    clearFilters();
    this.searchText = '';
  }

  mounted(){
    this.getList();
  }

  getList(){
    this.nodeIdSelect = ''
    this.conServProxy.findPcNodeList()
        .then(res=>{
          this.data = res.data;
        })
  }

  confirmRemoteNode(nodeId){
    //
    const dto = new CloseNodeDto();
    dto.nodeId= nodeId;
    this.conServProxy.closePcNode(dto)
      .then(res=>{
        this.getList();
      })
  }

  search(){
    this.conServProxy.findPcNodeList()
        .then(res => {
          let newData = res.data;
          this.data = newData
          if (this.nodeIdSelect){
            this.data = newData.filter( (item) => item.nodeId.indexOf(this.nodeIdSelect.trim().toUpperCase()) != -1)
          }
        })
  }
}
